export default "__VITE_ASSET__BLiwWeWB__"